import { z } from 'zod'

export const PHONE_PATTERN = /^[0-9 ()+.-]{6,20}$/

export const PASSWORD_MIN_LENGTH = 12

export const updateProfileSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, { message: 'profile.validation.name_required' })
      .max(255, { message: 'profile.validation.name_max' }),
    email: z
      .string()
      .trim()
      .min(1, { message: 'profile.validation.email_required' })
      .email({ message: 'profile.validation.email_invalid' })
      .max(255, { message: 'profile.validation.email_max' }),
    phone: z
      .string()
      .trim()
      .max(30, { message: 'profile.validation.phone_invalid' })
      .refine((v) => v === '' || PHONE_PATTERN.test(v), { message: 'profile.validation.phone_invalid' })
      .optional()
      .nullable(),
    current_password: z.string().optional(),
    password: z
      .string()
      .min(PASSWORD_MIN_LENGTH, { message: 'profile.validation.password_min' })
      .optional()
      .or(z.literal('')),
    password_confirmation: z.string().optional().or(z.literal('')),
  })
  .refine((d) => !d.password || d.password === d.password_confirmation, {
    message: 'profile.validation.password_mismatch',
    path: ['password_confirmation'],
  })
  .refine((d) => !d.password || (d.current_password !== undefined && d.current_password.length > 0), {
    message: 'profile.validation.current_password_required',
    path: ['current_password'],
  })

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>
